import { useLang } from "@/i18n/LanguageContext";

export default function PageHeader({ title, subtitle, testId }) {
  useLang();
  return (
    <section className="relative overflow-hidden bg-[#062B2B] pt-32 pb-14 md:pb-20">
      <div className="absolute inset-0 bg-radial-teal" />
      <div className="pointer-events-none absolute -start-20 top-0 h-64 w-64 rounded-full bg-[#0D9488]/10 blur-3xl" />
      <div className="pointer-events-none absolute -end-20 bottom-0 h-64 w-64 rounded-full bg-[#2DD4BF]/8 blur-3xl" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <span className="inline-block h-1.5 w-10 rounded-full bg-[#2DD4BF]" />
        <h1 data-testid={testId} className="mt-5 animate-fade-up font-display text-4xl font-bold tracking-tight text-white sm:text-5xl">
          {title}
        </h1>
        {subtitle && <p className="mt-4 max-w-2xl animate-fade-up text-base text-zinc-400 delay-100 md:text-lg">{subtitle}</p>}
      </div>
    </section>
  );
}
